export type ObjArrayItem = {
  id: string | number;
  [key: string]: any,
};

export const getIds = (arr: ObjArrayItem[]): string[] | number[] => {
  return arr.reduce((acc: string[] | number[], el) => {
    if (el.id !== 'all') {
      //@ts-ignore
      acc.push(el.id);
    }
    return acc;
  }, []);
}


export const getObjIds = (obj: ObjArrayItem): (string | number) => {
  return obj.id;
}
